export const PARTNER_LINE_ITEM_CONTENT_MAX_WIDTH = 1120;
